declare global {
  interface Window {
    _klOnsite: any[];
  }
}

/**
 * Klaviyo Trigger Popup
 *
 * @description This class handles the Klaviyo form trigger popup.
 * @example

Shopify Schema settings:

{
    "id": "klaviyo_form_trigger",
    "type": "text",
    "label": "Klaviyo form ID",
    "info": "The ID of the Klaviyo form to trigger when the announcement is clicked."
},
{
    "id": "klaviyo_form_trigger_mobile",
    "type": "text",
    "label": "Klaviyo form ID (mobile)",
    "info": "Optional. The ID of the Klaviyo form to trigger when the announcement is clicked on mobile. Leave blank to use the desktop form."
},

Liquid:

{% liquid
    assign klaviyo_form_trigger = block.settings.klaviyo_form_trigger
    assign klaviyo_form_trigger_mobile = block.settings.klaviyo_form_trigger_mobile
%}
{%- if block.settings.text != blank -%}
    <div {{ block_attributes }}
{% if klaviyo_form_trigger != blank or klaviyo_form_trigger_mobile != blank %}role="button"{% endif %}
{% if klaviyo_form_trigger != blank %}data-klaviyo-form-trigger="{{ klaviyo_form_trigger }}"{% endif %}
{% if klaviyo_form_trigger_mobile != blank %}data-klaviyo-form-trigger-mobile="{{ klaviyo_form_trigger_mobile }}"{% endif %}
    >
 */
class KlaviyoTriggerPopup {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      document
        .querySelector("[data-klaviyo-form-trigger], [data-klaviyo-form-trigger-mobile]")
        ?.addEventListener("click", function (e) {
          const desktopFormId = document
            .querySelector("[data-klaviyo-form-trigger]")
            ?.getAttribute("data-klaviyo-form-trigger");
          const mobileFormId = document
            .querySelector("[data-klaviyo-form-trigger-mobile]")
            ?.getAttribute("data-klaviyo-form-trigger-mobile");
          // Depending on breakpoint, open the correct form
          const formId = klaviyoTriggerPopup.isMobile() && mobileFormId ? mobileFormId : desktopFormId;

          if (formId) {
            e.preventDefault();
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(["openForm", formId]);
          } else {
            console.error(
              "No form ID found to trigger Klaviyo form popup. Add a data-klaviyo-form-trigger attribute to the element.",
              e.target
            );
          }
        });
    });
  }
  private isMobile() {
    return window.innerWidth < 768;
  }
}

const klaviyoTriggerPopup = new KlaviyoTriggerPopup();
export { klaviyoTriggerPopup };
